module.exports = __webpack_public_path__ + "img/20190827144140539.727bb1aa.jpg";